// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'reply';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.208 16.992V7.344a3.38 3.38 0 0 0-3.384-3.384H.576' />
    <path d='M3.96 7.344.576 3.96 3.96.576' />
  </g>
);

export const viewBox = '0 0 18 18';
